// ============================================================================
// session-guard.js — Tratamento global de expiração de sessão.
// ----------------------------------------------------------------------------
// IIFE autossuficiente, carregado cedo no <head> (header.php, logo após jQuery,
// antes de DataTables/Select2). NÃO depende de utils.js.
//
// Detecta respostas de sessão expirada (HTTP 401 ou header X-Sessao-Expirada:1),
// SUPRIME o erro técnico e redireciona ao login já na 1ª tentativa, preservando
// a URL atual em ?redirect=... (para retorno pós-login). Um guard garante um
// ÚNICO redirecionamento mesmo com várias requisições falhando ao mesmo tempo.
//
// 403 (permissão / CSRF com sessão válida) NÃO é tratado aqui — segue exibindo
// a mensagem normal, evitando deslogar usuário ainda autenticado.
//
// Cobertura: expõe handleIfExpired() para o mostraErro() (suprime o toast na
// fonte, pois o callback local roda antes do ajaxError global) E liga seu próprio
// $(document).ajaxError (cobre Select2/DataTables/chamadas sem callback).
// ============================================================================
(function () {
    'use strict';

    var redirecionando = false;
    var DELAY_AVISO_MS = 1500;

    // Está na própria tela de login? (evita loop de redirecionamento)
    function naTelaDeLogin() {
        try {
            var seg = (location.pathname || '').split('/').filter(Boolean).pop() || '';
            return seg.split('?')[0] === 'login';
        } catch (e) {
            return false;
        }
    }

    // A resposta indica sessão expirada / não autenticada?
    function ehSessaoExpirada(jqXHR) {
        if (!jqXHR) return false;
        if (jqXHR.status === 401) return true;
        try {
            if (typeof jqXHR.getResponseHeader === 'function' &&
                jqXHR.getResponseHeader('X-Sessao-Expirada') === '1') {
                return true;
            }
        } catch (e) { /* alguns XHR não expõem o header — ignora */ }
        return false;
    }

    function esconderSpinner() {
        try {
            if (typeof window.jQuery !== 'undefined') {
                window.jQuery('.loading-overlay').stop(true, true).hide();
            }
        } catch (e) { /* sem jQuery/spinner — ignora */ }
    }

    function redirecionarParaLogin() {
        if (redirecionando) return;
        redirecionando = true;

        esconderSpinner();

        var destino = 'login?redirect=' + encodeURIComponent(location.pathname + location.search);

        // Aviso breve e amigável (não-técnico) antes de navegar. Puramente
        // cosmético: o redirecionamento é garantido pelo setTimeout abaixo.
        try {
            if (typeof Swal !== 'undefined') {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'info',
                    title: 'Sua sessão expirou',
                    text: 'Redirecionando para o login…',
                    timer: DELAY_AVISO_MS,
                    timerProgressBar: true,
                    showConfirmButton: false
                });
                setTimeout(function () { window.location.replace(destino); }, DELAY_AVISO_MS);
                return;
            }
        } catch (e) { /* Swal indisponível — cai no redirect imediato */ }

        window.location.replace(destino);
    }

    // Núcleo: retorna true se tratou (sessão expirada) — o chamador deve
    // SUPRIMIR qualquer mensagem de erro. Retorna false caso contrário.
    function handleIfExpired(jqXHR) {
        try {
            if (naTelaDeLogin()) return false;     // não redireciona estando no login
            if (!ehSessaoExpirada(jqXHR)) return false;
            redirecionarParaLogin();               // self-guarded (1 único redirect)
            return true;
        } catch (e) {
            return false;
        }
    }

    window.ErlsoftSession = {
        handleIfExpired: handleIfExpired,
        isExpirada: ehSessaoExpirada
    };

    // Catch-all global: cobre AJAX sem callback de erro (DataTables/Select2).
    function bindAjaxError($) {
        $(document).ajaxError(function (event, jqXHR) {
            handleIfExpired(jqXHR);
        });
    }

    if (typeof window.jQuery !== 'undefined') {
        bindAjaxError(window.jQuery);
    } else {
        document.addEventListener('DOMContentLoaded', function () {
            if (typeof window.jQuery !== 'undefined') bindAjaxError(window.jQuery);
        });
    }
})();
